import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=efcde5ba&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=efcde5ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efcde5ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efcde5ba')) {
      api.createRecord('efcde5ba', component.options)
    } else {
      api.reload('efcde5ba', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=efcde5ba&scoped=true&", function () {
      api.rerender('efcde5ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28Se2gCaGzT4S/JS/comp/DocBox.vue"
export default component.exports